import { TextField as MUITextField, Typography } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CloseIcon from "@material-ui/icons/Close";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import { Alert } from "@material-ui/lab";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import PersonalInfoSection from "components/ltr-request-document/components/PersonalInfoSection";
import ButtonController from "components/request-document/components/ButtonController";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import useSmartSubName from "components/request-document/hooks/useSmartSubName";
import { useFormik } from "formik";
import nationalities from "i18n-nationality";
import {
  REQUEST_DOCUMENT_STEP_LTR,
  RoleId,
  STATUS_PROCESS
} from "libs/configs/constant";
import { LTR_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  defaultChildren,
  defaultDirectInvestmentTable,
  defaultEducationData,
  defaultGovernmentBond,
  defaultRealEstate,
  defaultSpouse,
  getDefaultRow,
  mapChildren,
  mapDirectInvestmentTable,
  mapEducationData,
  mapGovernmentBond,
  mapRealEstate,
  mapSpouse,
  personalFieldResolver
} from "libs/utils/form";
import { formatDate } from "libs/utils/format";
import { convertMRZDate } from "libs/utils/mrzUtils";
import { get, pick } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addPersonal,
  addPersonalSlice,
  selectAddPersonal
} from "redux/modules/addPersonalSlice";
import { canEditForm } from "redux/modules/authSlice";
import { companySlice } from "redux/modules/companySlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPassportState } from "redux/modules/passportSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartFormSlice, addWorkPermit, getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import * as yup from "yup";
const TextField = React.memo(MUITextField);

export default function UserProfile() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const subName = useSmartSubName();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const passportState = useSelector(selectPassportState);
  const personalDetail = useSelector(selectPersonalDetail);
  const addPersonalState = useSelector(selectAddPersonal);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const smartform = useSelector(selectCurrentSmartForm);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const canEdit = useSelector(canEditForm);
  const assignmentConfig = get(masterData, "assignmentConfig", []);
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });

  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const personalId = get(personalDetail, "personalID", "");
  const ocrFirstName = get(passportState, "detail.firstName", "");
  const ocrLastName = get(passportState, "detail.lastName", "");
  const ocrBirthDate = convertMRZDate(
    get(passportState, "detail.birthDate", "")
  );
  const nationalityAlpha3 = get(passportState, "detail.nationality", "");
  const nationalityName = nationalities.getName(nationalityAlpha3, "en");
  const ocrNationalityID = get(
    nationalityConfig.find((v) => v.nationalityName === nationalityName),
    "nationalityID",
    ""
  );
  const ocrExpirationDate = convertMRZDate(
    get(passportState, "detail.expirationDate", "")
  );
  const ocrSex = get(passportState, "detail.sex", "").slice(0, 1).toUpperCase();
  const ocrDocumentNumber = get(passportState, "detail.documentNumber", "");

  //scroll
  const info = useRef(null);
  const income = useRef(null);
  const investment = useRef(null);
  const assets = useRef(null);
  const medical = useRef(null);
  const detailapplicantMenu = useRef(null);
  const BottomButton = useRef(null);
  const [BottomVisible, setBottomVisible] = useState(false);
  const [MenuOpen, setMenuOpen] = useState(false);
  const [hintMenu, setHintMenu] = useState(false);

  const personal = pick(get(smartform, "personal", {}), [
    "titleID",
    "personalID",
    "firstname",
    "middleName",
    "lastName",
    "nationalityID",
    "birthDate",
    "email",
    "placeOfBirth",
    "gender",
    "passportNumber",
    "dateofIssue",
    "validuntil",
    "visatypeID",
    "issuedAt",
    "mobile",
    "soi",
    "road",
    "titleOther",
    "maritalID",
    "MaritalOther",
    "addressInHomeCountry",
    "addressInThailand",
    "ProvinceId",
    "SubDistrictId",
    "DistrictId",
    "identificationNumber",
    "accommodationID",
    "houseNumber",
  ]);

  const detailList = [
    "Marittal",
    "PersonalAddressInHome",
    "AddressInThai",
    "SubDistrict",
    "District",
    "Province",
    "Zipcode",
    "PhoneNumber",
    "Email",
    "assignmentId",
    "assignmentId2",
    "assignmentId3",
    "DetailofExpertise",
    "Spouse",
    "Children",
    "EducationOther",
    "Education",
    "ReferencePersonName",
    "sourcesOfincomeID",
    "sourcesOfincomeOther",
    "GovernmentBond",
    "RealEstate",
    "DirectInvestment",
    "PersonalAddressInThai",
    "GovernmentBondTable",
    "PersonalResidenceType",
    "PersonalProvince",
    "PersonalDistrict",
    "PersonalSubDistrict",
    "PersonalZipcode",
    "PersonalOccupation",
    "ContactPersonInThai",
    "ContactRelationship",
    "ContactEmail",
    "ContactMobile",
    "TotalCurrent",
    "TotalCurrentEnd",
    "IncomeTotalCurrent",
    "Lastyear",
    "IncomeLastYear",
    "Last2Year",
    "IncomeLast2Year",
    "TotalTHB",
    "TotalUSD",
    "RealEstateTable",
    "TotalAssetsUSD",
    "AssetsDeposit",
    "AssetsDepositValue",
    "AssetsPrivateCommercial",
    "AssetsPrivateCommercialValue",
    "AssetsCloselyStocks",
    "AssetsCloselyStocksValue",
    "AssetsPubliclyTraded",
    "AssetsPubliclyTradedValue",
    "AssetsGoldAccount",
    "AssetsGoldAccountValue",
    "AssetsOther",
    "AssetsOtherValue",
    "HealthInsurance",
    "Validity",
    "ValidityDateIssue",
    "ValidityDateExpiry",
    "SubmitLater",
    "SocialSecurity",
    "SocialSecurityDate",
    "DepositOfNoless",
    "DirectInvestmentTable",
  ];
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce((p, c) => ({ ...p, [c.smartName]: c }), {});

  useEffect(() => {
    dispatch(
      getMasterData({
        nationalityConfig: true,
        AssignmentConfig: true,
        EducationConfig: true,
        CountryConfig: true,
        titleConfig: true,
        sourcesOfincomeConfig: true,
        accommodationConfig: true,
        typeOfbusinessindustryConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(
        getSmartFormFieldConfig({
          smartserviceId: smartServiceId,
          smartserviceGroupID: "LTR",
        })
      );
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
          smartserviceGroupID: "LTR",
        })
      );
    }
  }, [dispatch, draftId, personalDetail, personalId, smartServiceId]);

  useEffect(() => {
    if (!addPersonalState.isLoading) {
      if (addPersonalState.isSuccess) {
        dispatch(addPersonalSlice.actions.clearAsyncState());
      } else if (addPersonalState.isFailure) {
        hideLoading();
        alert(addPersonalState.error?.message);
        dispatch(addPersonalSlice.actions.clearAsyncState());
      }
    }
  }, [addPersonalState, dispatch, hideLoading]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        dispatch(
          getSmartForm({
            smartserviceId: smartServiceId,
            draftId,
            personalId,
            smartserviceGroupID: "LTR",
          })
        );
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_STEP));
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, isSaveDraft]);

  const handleOnNext = () => {
    dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_WORKPERMITSTEP));
    dispatch(companySlice.actions.clearAll());
    return;
  };
  const handleOnBack = () => {
    dispatch(setSmartFormStep(LTR_STEP.UPLOAD_PASSPORT));
    return;
  };
  const validationSchema = yup.object({});
  // const defaultType = get(smartFormFieldConfig, "data.defaultType", []).reduce(
  //   (p, c) => ({ ...p, [c.smartName]: c }),
  //   {}
  // );
  // console.log(defaultType);
  const callAPISubmit = async (values) => {
    showLoading();

    const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
    const documentFields = Object.keys(values.document);

    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );

    const getValue = (field) => {
      switch (field.smartName) {
        case "Spouse": {
          const spouseName = get(values, `document.${field.smartName}`, []);
          const value = spouseName.filter((v) => !!v.SpouseName);
          return value || null;
        }
        case "Children": {
          const childrenName = get(values, `document.${field.smartName}`, []);
          const value = childrenName.filter((v) => !!v.ChildrenName);
          return value || null;
        }
        case "Education": {
          const educationId = get(values, `document.${field.smartName}`, {
            EducationConfigID: null,
            data: [],
          });
          const data = educationId.data.filter((v) => !!v.educationName);
          return {
            EducationConfigID: educationId.EducationConfigID,
            data: data.length ? data : null,
          };
        }
        case "GovernmentBondTable": {
          const BondName = get(values, `document.${field.smartName}`, []);
          const value = BondName.filter((v) => !!v.BondName).map((x) => {
            return {
              GovernmentBondID: x.GovernmentBondID,
              GovernmentBond: x.GovernmentBond,
              BondName: x.BondName,
              PurchasingAmountTHB:
                x.PurchasingAmountTHB === "" ? 0 : x.PurchasingAmountTHB,
              IssueDate: x.IssueDate === "" ? null : x.IssueDate,
              MaturityDate: x.MaturityDate === "" ? null : x.MaturityDate,
              AgeYear: x.AgeYear,
              Status: x.Status,
            };
          });

          return value || null;
        }
        case "RealEstateTable": {
          const PropertyName = get(values, `document.${field.smartName}`, []);
          const value = PropertyName.filter((v) => !!v.PropertyName).map(
            (x) => {
              return {
                RealEstateID: x.RealEstateID,
                RealEstate: x.RealEstate,
                PropertyName: x.PropertyName,
                Address: x.Address,
                DateOwnership: x.DateOwnership === "" ? null : x.DateOwnership,
                AcquisitionCost:
                  x.AcquisitionCost === "" ? 0 : x.AcquisitionCost,
                Status: x.Status,
              };
            }
          );

          return value || null;
        }
        default:
          return get(values, `document.${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null, // get(smartform, "survey", null), // TODO wait for support case edit
      visaissuance: null, // get(smartform, "visaissuance", null), // TODO wait for support case edit
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: getSmartId(field),
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    await dispatch(
      addPersonal({
        ...personalFieldResolver(values.personal),
        visatypeID: null,
      })
    );
    await dispatch(
      addWorkPermit({
        data: prepareData,
      })
    );
  };

  const HasAddressInThai = !!get(detail, "AddressInThai.value", "");
  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      personal: {
        titleID: get(personal, "titleID", ""),
        personalID: get(personal, "personalID", ""),
        fistName: ocrFirstName || get(personal, "firstname", ""),
        middleName: get(personal, "middleName", "") || "",
        lastName: ocrLastName || get(personal, "lastName", ""),
        nationalityID:
          ocrNationalityID || get(personal, "nationalityID", "") || "",
        birthDate: formatDate(
          ocrBirthDate || get(personal, "birthDate", "") || ""
        ),
        email: get(personal, "email", "") || "",
        mobile: get(personal, "mobile", "") || "",
        placeOfBirth: get(personal, "placeOfBirth", "") || "",
        gender: ocrSex || get(personal, "gender", "M") || "M",
        passportNumber:
          ocrDocumentNumber || get(personal, "passportNumber", "") || "",
        issuedAt: get(personal, "issuedAt", ""),
        soi: get(personal, "soi", ""),
        road: get(personal, "road", ""),
        dateofIssue: formatDate(get(personal, "dateofIssue", "") || ""),
        validuntil: formatDate(
          ocrExpirationDate || get(personal, "validuntil", "") || ""
        ),
        visatypeID: null,
        titleOther: get(personal, "titleOther", ""),
        MaritalID: get(personal, "maritalID", "S"),
        MaritalOther: get(personal, "MaritalOther", ""),
        addressInHomeCountry: get(personal, "addressInHomeCountry", ""),
        addressInThailand: get(personal, "addressInThailand", ""),
        // ProvinceId: get(personal, "ProvinceId", ""),
        // SubDistrictId: get(personal, "SubDistrictId", ""),
        // DistrictId: get(personal, "DistrictId", ""),
        identificationNumber: get(personal, "identificationNumber", ""),
        accommodationID: get(personal, "accommodationID", ""),
        houseNumber: get(personal, "houseNumber", ""),
      },
      document: {
        Marittal: get(detail, "Marittal.value", "S"),
        PersonalAddressInHome: get(detail, "PersonalAddressInHome.value", ""),
        HasAddressInThai,
        AddressInThai: get(detail, "AddressInThai.value", ""),
        SubDistrict: get(detail, "SubDistrict.value", ""),
        District: get(detail, "District.value", ""),
        Province: get(detail, "Province.value", ""),
        Zipcode: get(detail, "Zipcode.value", ""),
        PhoneNumber: get(detail, "PhoneNumber.value", ""),
        Email: get(detail, "Email.value", ""),
        assignmentId: get(detail, "assignmentId.value", ""),
        assignmentId2: get(detail, "assignmentId2.value", ""),
        assignmentId3: get(detail, "assignmentId.3value", ""),
        DetailofExpertise: get(detail, "DetailofExpertise.value", ""),
        ReferencePersonName: get(detail, "ReferencePersonName.value", ""),
        sourcesOfincomeID: get(detail, "sourcesOfincomeID.value", ""),
        sourcesOfincomeOther: get(detail, "sourcesOfincomeOther.value", ""),
        GovernmentBond: get(detail, "GovernmentBond.value", ""),
        RealEstate: get(detail, "RealEstate.value", ""),
        DirectInvestment: get(detail, "DirectInvestment.value", ""),
        PersonalAddressInThai: get(detail, "PersonalAddressInThai.value", ""),
        PersonalResidenceType: get(detail, "PersonalResidenceType.value", ""),
        PersonalProvince: get(detail, "PersonalProvince.value", ""),
        PersonalDistrict: get(detail, "PersonalDistrict.value", ""),
        PersonalSubDistrict: get(detail, "PersonalSubDistrict.value", ""),
        PersonalZipcode: get(detail, "PersonalZipcode.value", ""),
        PersonalOccupation: get(detail, "PersonalOccupation.value", ""),
        ContactPersonInThai: get(detail, "ContactPersonInThai.value", ""),
        ContactRelationship: get(detail, "ContactRelationship.value", ""),
        ContactEmail: get(detail, "ContactEmail.value", ""),
        ContactMobile: get(detail, "ContactMobile.value", ""),
        TotalCurrent: get(detail, "TotalCurrent.value", ""),
        TotalCurrentEnd: get(detail, "TotalCurrentEnd.value", ""),
        IncomeTotalCurrent: get(detail, "IncomeTotalCurrent.value", ""),
        Lastyear: get(detail, "Lastyear.value", ""),
        IncomeLastYear: get(detail, "IncomeLastYear.value", ""),
        Last2Year: get(detail, "Last2Year.value", ""),
        IncomeLast2Year: get(detail, "IncomeLast2Year.value", ""),
        TotalTHB: get(detail, "TotalTHB.value", ""),
        TotalUSD: get(detail, "TotalUSD.value", ""),
        TotalAssetsUSD: get(detail, "TotalAssetsUSD.value", ""),
        AssetsDeposit: get(detail, "AssetsDeposit.value", ""),
        AssetsDepositValue: get(detail, "AssetsDepositValue.value", ""),
        AssetsPrivateCommercial: get(
          detail,
          "AssetsPrivateCommercial.value",
          ""
        ),
        AssetsPrivateCommercialValue: get(
          detail,
          "AssetsPrivateCommercialValue.value",
          ""
        ),
        AssetsCloselyStocks: get(detail, "AssetsCloselyStocks.value", ""),
        AssetsCloselyStocksValue: get(
          detail,
          "AssetsCloselyStocksValue.value",
          ""
        ),
        AssetsPubliclyTraded: get(detail, "AssetsPubliclyTraded.value", ""),
        AssetsPubliclyTradedValue: get(
          detail,
          "AssetsPubliclyTradedValue.value",
          ""
        ),
        AssetsGoldAccount: get(detail, "AssetsGoldAccount.value", ""),
        AssetsGoldAccountValue: get(detail, "AssetsGoldAccountValue.value", ""),
        AssetsOther: get(detail, "AssetsOther.value", ""),
        AssetsOtherValue: get(detail, "AssetsOtherValue.value", ""),
        HealthInsurance: get(detail, "HealthInsurance.value", ""),
        Validity: get(detail, "Validity.value", ""),
        ValidityDateIssue: get(detail, "ValidityDateIssue.value", ""),
        ValidityDateExpiry: get(detail, "ValidityDateExpiry.value", ""),
        SubmitLater: get(detail, "SubmitLater.value", ""),
        SocialSecurity: get(detail, "SocialSecurity.value", ""),
        SocialSecurityDate: get(detail, "SocialSecurityDate.value", ""),
        DepositOfNoless: get(detail, "DepositOfNoless.value", ""),
        Spouse: getDefaultRow(detail, "Spouse.value", defaultSpouse).map(
          mapSpouse
        ),
        GovernmentBondTable: getDefaultRow(
          detail,
          "GovernmentBondTable.value",
          defaultGovernmentBond
        ).map(mapGovernmentBond),
        RealEstateTable: getDefaultRow(
          detail,
          "RealEstateTable.value",
          defaultRealEstate
        ).map(mapRealEstate),
        DirectInvestmentTable: getDefaultRow(
          detail,
          "DirectInvestmentTable.value",
          defaultDirectInvestmentTable
        ).map(mapDirectInvestmentTable),

        Children: getDefaultRow(detail, "Children.value", defaultChildren).map(
          mapChildren
        ),
        EducationOther: get(detail, "EducationOther.value", ""),
        Education: {
          EducationConfigID: null,
          data: getDefaultRow(
            detail,
            "Education.value.data",
            defaultEducationData
          ).map(mapEducationData),
        },
      },
    },
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    onSubmit: async (values) => {
      if (!canEdit) {
        dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_STEP));
        return;
      }
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => { };
    formik.handleChange = () => { };
    formik.setFieldValue = () => { };
  }

  //Scrooling
  const onMenuClick = (params) => {
    switch (params) {
      case "info":
        return info?.current.scrollIntoView({ behavior: "smooth" });
      case "income":
        return income?.current.scrollIntoView({ behavior: "smooth" });
      case "investment":
        return investment?.current.scrollIntoView({ behavior: "smooth" });
      case "assets":
        return assets?.current.scrollIntoView({ behavior: "smooth" });
      case "medical":
        return medical?.current.scrollIntoView({
          behavior: "smooth",
        });
      case "detailapplicantMenu":
        return detailapplicantMenu?.current.scrollIntoView({
          behavior: "smooth",
        });
      default:
        break;
    }
    // if (params === "info") {
    //   info?.current.scrollIntoView({ behavior: "smooth" });
    //   console.log(params);
    // }
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const maxScroll = document.body.scrollHeight - window.innerHeight;

      if (window.scrollY > 400 && window.scrollY < maxScroll - 100) {
        setBottomVisible(true);
      } else {
        setBottomVisible(false);
      }
    });

    // }
  }, []);

  return (
    <div className={classes.root}>
      {!MenuOpen ? (
        <>
          <div
            style={{
              position: "fixed",
              top: "30%",
              right: 0,
              zIndex: "1999",
              borderRadius: "0.25rem",
              borderWidth: "1px",
              padding: "10px",
              backgroundColor: "#97BAD0",
              boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
            }}
          >
            <MenuOpenIcon color="white" onClick={() => setMenuOpen(true)} />
            {!hintMenu ? (
              <div
                style={{
                  position: "absolute",
                  top: "30%",
                  left: "-50%",
                  color: "#fff",
                  minWidth: "200px",
                  background: "#2DCE98",
                  padding: "10px 10px",
                  borderRadius: "0.25rem",
                  width: "100%",
                  transform: "translateX(-100%) translateY(-50%)",
                  zIndex: "1999",
                }}
                onClick={() => setHintMenu(true)}
              >
                <Typography>This Section Menu</Typography>
              </div>
            ) : null}
          </div>
        </>
      ) : (
        <div
          style={{
            position: "fixed",
            top: "30%",
            right: 0,
            zIndex: "1999",
            borderRadius: "0.25rem",
            borderWidth: "1px",
            padding: "10px",
            backgroundColor: "#F7FAFC",
            boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
            maxWidth: "600px",
            marginRight: "20px",
          }}
        >
          <CloseIcon
            onClick={() => setMenuOpen(false)}
            style={{ float: "right" }}
          />
          <ContentTitle title="Section" />
          <Typography
            onClick={() => onMenuClick("info")}
            paragraph
            component="span"
            color="primary"
            variant="body1"
          >
            ● Personal Information
          </Typography>
          {/* <br />
          <Typography
            onClick={() => onMenuClick("income")}
            paragraph
            component="span"
            color="primary"
            variant="body1"
          >
            ● Personal Income
          </Typography>
          <br />
          <Typography
            onClick={() => onMenuClick("investment")}
            paragraph
            component="span"
            color="primary"
            variant="body1"
          >
            ● Investment in Thailand
          </Typography>
          <br />
          <Typography
            onClick={() => onMenuClick("assets")}
            paragraph
            component="span"
            color="primary"
            variant="body1"
          >
            ● Personal Assets Value
          </Typography>
          <br />

          <Typography
            onClick={() => onMenuClick("medical")}
            paragraph
            component="span"
            color="primary"
            variant="body1"
          >
            ● Means of medical expense
          </Typography>
          <br /> */}
        </div>
      )}
      <ContentTitle
        title="Application Form"
        subTitle={`APPLICATION FOR QUALIFICATION ENDORSEMENT FOR WORKPERMIT`}
      />
      {smartform.draftRemark && <Alert severity="error" style={{ marginTop: 18, marginBottom: 18 }}>{smartform.draftRemark}</Alert>}
      <Steper currentStep={1} isLTR stepInfo={REQUEST_DOCUMENT_STEP_LTR} />
      {/* <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} /> */}
      <form onSubmit={formik.handleSubmit} disabled>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <info ref={info}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={7}>
                    <Typography variant="h6" className={classes.tableTitle}>
                      Personal Information
                    </Typography>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <PersonalInfoSection formik={formik} disabled />
              </TableBody>
            </Table>
          </info>
          {/* Details of applicant’s work in Thailand */}
        </TableContainer>

        {BottomVisible ? (
          <div
            ref={{ BottomButton }}
            style={{
              position: "fixed",
              left: 0,
              bottom: 0,
              width: "100%",
              backgroundColor: "#F7FAFC",
              borderTopRightRadius: "25px",
              borderTopLeftRadius: "25px",
              color: "white",
              textAlign: "center",
              padding: "10px",
              zIndex: "100",
            }}
          >
            <ButtonController
              onClickSaveDraft={async () => {
                await setSaveDraft(true);
                await callAPISubmit(formik.values);

                await dispatch(
                  getSmartForm({
                    smartserviceId: smartServiceId,
                    draftId,
                    personalId,
                    smartserviceGroupID: "LTR",
                  })
                );
              }}
              onClickNext={async () => {
                if (canEdit) {
                  await formik.handleSubmit();

                  await dispatch(
                    getSmartForm({
                      smartserviceId: smartServiceId,
                      draftId,
                      personalId,
                      smartserviceGroupID: "LTR",
                    })
                  );
                }
                await handleOnNext();
              }}
              onClickBack={() => handleOnBack()}
              isLTR
            />
          </div>
        ) : (
          <ButtonController
            onClickSaveDraft={async () => {
              await setSaveDraft(true);
              await callAPISubmit(formik.values);

              await dispatch(
                getSmartForm({
                  smartserviceId: smartServiceId,
                  draftId,
                  personalId,
                  smartserviceGroupID: "LTR",
                })
              );
            }}
            onClickNext={async () => {
              if (canEdit) {
                await formik.handleSubmit();

                await dispatch(
                  getSmartForm({
                    smartserviceId: smartServiceId,
                    draftId,
                    personalId,
                    smartserviceGroupID: "LTR",
                  })
                );
              }
              await handleOnNext();
            }}
            onClickBack={() => handleOnBack()}
            isLTR
          />
        )}
      </form>
    </div>
  );
}
